import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class PrivacyNoticeApi extends BaseApi {
    constructor(client) {
        super(client, '/privacy-notice');
    }

    async generateDraft(data) {
        try {
            const response = await this.client.post(`${this.basePath}/generate-draft`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getChecklist(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/checklist`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async submit(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/submit`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async publish(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/publish`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async newVersion(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/new-version`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
